import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { type FormControl } from '@angular/forms';
import { toExternalHref } from '@frontendlib/common/utils/external-href';
import { InputComponent } from '@frontendlib/components/controls/input/input.component';
import { LinkComponent } from '@frontendlib/components/components/link/link.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { startWith, switchMap } from 'rxjs';

/**
 * An event's meeting link: an input, with "Join meeting" beside it once it holds a link.
 * When it is not `editable` (an invitation, which only its organizer may change) it is a link.
 * Only an http(s) link opens; anything else shows as plain text.
 */
@Component({
  selector: 'stch-meeting-link-field',
  templateUrl: './meeting-link-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputComponent, LinkComponent, IconComponent],
  host: {
    class: 'block min-w-0',
  },
})
export class MeetingLinkFieldComponent {
  public readonly control = input.required<FormControl<string>>();
  public readonly editable = input(true);

  private readonly value = toSignal(
    toObservable(this.control).pipe(switchMap((control) => control.valueChanges.pipe(startWith(control.value)))),
    { initialValue: '' },
  );

  protected readonly text = computed(() => (this.value() ?? '').trim());
  protected readonly href = computed(() => toExternalHref(this.text()));
}
